import { Injectable } from '@angular/core';
import {
    BaseHttpService,
    Create, Delete,
    GetById, Update,
    UriBuilderParams
} from '@app/core/services/base/base-http.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { DrQueryParams } from '@app/core/services/base/base-service-with-bundle.service';
import { map } from 'rxjs/operators';
import { Office } from '@app/shared/models/office';
import { BaseWithIdList } from '@app/shared/models/list';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { Department } from '@app/shared/models/department';
import { Client } from '@app/shared/models/client';

export class OfficeUriBuilderParams extends UriBuilderParams<Office> {
    private readonly _client: string;
    private readonly _department: string;

    get client() {
        return this._client;
    }

    get department() {
        return this._department;
    }

    constructor(client?: Client | string, department?: Department | string, office?: Office | string) {
        super(office);
        this._client = this.getParamId(client);
        this._department = this.getParamId(department);
    }

    public buildUri(): string {
        let uri = `/${BackendUriUnits.CLIENTS}/${BackendUriUnits.SETTINGS}/${BackendUriUnits.DATA}${this.department ? `/${BackendUriUnits.DEPARTMENTS}/${this.department}` : ``}`;
        uri += this.simpleUriBuild(BackendUriUnits.OFFICES);
        return uri;
    }
}

@Injectable({ providedIn: 'root' })
export class OfficeService extends BaseHttpService<Office, OfficeUriBuilderParams>
                           implements GetById<Office, OfficeUriBuilderParams>,
                                      Create<Office, OfficeUriBuilderParams>,
                                      Update<Office, OfficeUriBuilderParams>,
                                      Delete<Office, OfficeUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(Office, httpServiceBundle, true);
    }

    // BASE METHODS ****************************************************************************************

    public query(uriParams: OfficeUriBuilderParams, params?: DrQueryParams, propOverride?: string): Observable<BaseWithIdList<Office>> {
        return this.queryBase(uriParams, params, propOverride)
                   .pipe(map(result => BaseWithIdList.upgradeFromBaseList(result)));
    }

    public getById(uriParams: OfficeUriBuilderParams): Observable<Office> {
        return this.getBaseById(uriParams, null, 'office');
    }

    public create(uriParams: OfficeUriBuilderParams, userToCreate: Office): Observable<Office> {
        return this.createBase(uriParams, userToCreate, null, 'office');
    }

    public update(uriParams: OfficeUriBuilderParams, userToUpdate: Office, params?: DrQueryParams): Observable<Office> {
        return this.updateBase(uriParams, userToUpdate, params, 'office');
    }

    public delete(uriParams: OfficeUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }

}
